import React, { Component } from 'react'
import { Table } from 'react-bootstrap';
import firebase from '../helpers/firebase';
import MakeUpRow from './MakeUpRow.js'

export default class extends Component {

  constructor() {
    super()

    this.state = {
      makeups: {},
      users: []
    }
  }

  componentDidMount() {
    this.getMakeUps()
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.getMakeUps()
    }
  }

  getMakeUps() {
    const { userId, userFilter } = this.props
    var ref = firebase.database().ref('makeups')

    if (userId) {
      ref = ref.orderByChild('userId')
        .equalTo(userId)
    }
    ref.once('value').then((snapshots) => {

      var makeups = []
      const makeupsObject = snapshots.val()
      const keys = Object.keys(makeupsObject)
      keys.forEach(key => {
        makeups.push({...(makeupsObject[key]), id: key})
      })

      if (userFilter) {
        makeups = makeups.filter(makeup => { return userFilter.indexOf(makeup.userId) >= 0 })
      }

      this.setState({makeups});
    });
  }

  render() {
    const { makeups } = this.state
    return (<Table striped bordered condensed hover>
      <thead>
        <tr>
          {this.props.userId ? null : <th>Applicant</th>}
          <th>Date</th>
          <th>Hours</th>
          <th>Requested by</th>
        </tr>
      </thead>
      <tbody>
        {
          makeups ? Object.keys(makeups).map(key => {
            return (
              <MakeUpRow makeup={makeups[key]} key={key} showName={!this.props.userId}/>
            )
          }) : null
        }
      </tbody>
    </Table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MakeUpTable.js